<template>
  <div>
    <h1>Add Preassessment</h1>
    <div class="row">
      <div class="row">
        <div class="small-4 columns">Name</div>
        <div class="small-8 columns">
          <input v-model="preassessmentObject.name" type="text" />
        </div>
      </div>
      <!--  -->
      <div class="row tag-container">
        <h4>Code Tags</h4>

        <div
          v-for="(codeTag, i) in preassessmentObject.question_code_tags.data"
          :key="i"
          class="row"
        >
          <div class="small-4 columns">
            <div>Tag</div>
            <select v-model="codeTag.id" style="width:90%">
              <option v-for="(tag, i) in tagOptions" :key="i" :value="tag.id">{{
                tag.name
              }}</option>
            </select>
          </div>
          <div class="small-6 columns">
            <div>count</div>
            <input id="" v-model="codeTag.count" type="text" name="" />
          </div>
          <div class="small-2 columns">
            <div class=" link" @click="removeCodeTag(i)">-Remove Tag</div>
          </div>
        </div>
        <div class=" link" @click="addCodeTags">+add code tag</div>
      </div>
      <!--  -->
      <div class="row tag-container">
        <h4>Game Tags</h4>

        <div
          v-for="(gameTag, i) in preassessmentObject.question_game_tags.data"
          :key="i"
          class="row"
        >
          <div class="small-4 columns">
            <div>Tag</div>
            <select v-model="gameTag.id" style="width:90%">
              <option v-for="(tag, i) in tagOptions" :key="i" :value="tag.id">{{
                tag.name
              }}</option>
            </select>
          </div>
          <div class="small-6 columns">
            <div>count</div>
            <input id="" v-model="gameTag.count" type="text" name="" />
          </div>
          <div class="small-2 columns">
            <div class=" link" @click="removeGameTag(i)">-Remove Tag</div>
          </div>
        </div>
        <div class=" link" @click="addGameTags">+add code tag</div>
      </div>
      <!--  -->
      <div class="row tag-container">
        <h4>MCQ Tags</h4>

        <div
          v-for="(MCQTag, i) in preassessmentObject.question_mcq_tags.data"
          :key="i"
          class="row"
        >
          <div class="small-4 columns">
            <div>Tag</div>
            <select v-model="MCQTag.id" style="width:90%">
              <option v-for="(tag, i) in tagOptions" :key="i" :value="tag.id">{{
                tag.name
              }}</option>
            </select>
          </div>
          <div class="small-6 columns">
            <div>count</div>
            <input id="" v-model="MCQTag.count" type="text" name="" />
          </div>
          <div class="small-2 columns">
            <div class=" link" @click="removeMCQTag(i)">-Remove Tag</div>
          </div>
        </div>
        <div class=" link" @click="addMCQTags">+add code tag</div>
      </div>
      <!--  -->
      <div class="row tag-container">
        <h4>Video Tags</h4>

        <div
          v-for="(videoTag, i) in preassessmentObject.question_video_tags.data"
          :key="i"
          class="row"
        >
          <div class="small-4 columns">
            <div>Tag</div>
            <select v-model="videoTag.id" style="width:90%">
              <option v-for="(tag, i) in tagOptions" :key="i" :value="tag.id">{{
                tag.name
              }}</option>
            </select>
          </div>
          <div class="small-6 columns">
            <div>count</div>
            <input id="" v-model="videoTag.count" type="text" name="" />
          </div>
          <div class="small-2 columns">
            <div class=" link" @click="removeVideoTag(i)">-Remove Tag</div>
          </div>
        </div>
        <div class=" link" @click="addVideoTags">+add code tag</div>
      </div>
      <!--  -->
      <div>
        <button class="button-green" @click="addPreassessment">
          Add Preassessment
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      preassessmentObject: {
        name: "",
        question_code_tags: { data: [] },
        question_game_tags: { data: [] },
        question_mcq_tags: { data: [] },
        question_video_tags: { data: [] },
      },
      tagOptions: [],
    }
  },
  mounted() {
    this.getTags()
  },
  methods: {
    removeCodeTag(i) {
      this.preassessmentObject.question_code_tags.data.splice(i, 1)
    },
    addCodeTags() {
      this.preassessmentObject.question_code_tags.data.push({
        id: "",
        count: 0,
      })
    },
    removeGameTag(i) {
      this.preassessmentObject.question_game_tags.data.splice(i, 1)
    },
    addGameTags() {
      this.preassessmentObject.question_game_tags.data.push({
        id: "",
        count: 0,
      })
    },
    removeMCQTag(i) {
      this.preassessmentObject.question_mcq_tags.data.splice(i, 1)
    },
    addMCQTags() {
      this.preassessmentObject.question_mcq_tags.data.push({
        id: "",
        count: 0,
      })
    },
    removeVideoTag(i) {
      this.preassessmentObject.question_video_tags.data.splice(i, 1)
    },
    addVideoTags() {
      this.preassessmentObject.question_video_tags.data.push({
        id: "",
        count: 0,
      })
    },
    addPreassessment() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}preassessments/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: this.preassessmentObject,
      }).then(() => {
        this.$router.push("/preassessments/")
      })
    },
    getTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.tagOptions = res.data.data
      })
    },
  },
}
</script>

<style>
.tag-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #d2d2d2;
  background-color: #ececec;
}
</style>
